/**
 * اقتصاد ستاره. سقف روزانه عمدی است: بدون آن، عدد ستاره تورم می‌گیرد و بی‌معنا می‌شود.
 * این جدول تنها منبع حقیقت است — اپ، ربات و سرور همه از همین‌جا می‌خوانند.
 */
export const STAR_VALUES = {
    habit_done: 10,
    habit_never_zero: 4,
    task_done: 5,
    water_goal: 15,
    exercise_logged: 20,
    sleep_logged: 5,
    full_day: 30,
    focus_complete: 30,
    streak_bonus: 0, // پویا — تابع پایین
    bot_bonus: 2,
};
/** حداکثر دفعاتی که هر دلیل در یک روز ستاره می‌دهد */
export const DAILY_CAPS = {
    habit_done: 8,
    habit_never_zero: 8,
    task_done: 10,
    water_goal: 1,
    exercise_logged: 1,
    sleep_logged: 1,
    full_day: 1,
    streak_bonus: 1,
    focus_complete: 8,
};
/** ۵ ستاره به ازای هر هفتهٔ کامل زنجیره، حداکثر ۵۰ */
export function streakBonus(streakDays) {
    return Math.min(50, Math.floor(streakDays / 7) * 5);
}
/** آیا این دلیل امروز هنوز ظرفیت دارد؟ */
export function canAward(entries, reason, localDate) {
    const cap = DAILY_CAPS[reason];
    if (cap === undefined)
        return true;
    const used = entries.filter((e) => e.localDate === localDate && e.reason === reason).length;
    return used < cap;
}
/** آستانهٔ ورود به سطح n */
export function levelThreshold(level) {
    return Math.round(100 * Math.pow(level, 1.5));
}
export function levelForStars(totalStars) {
    let lvl = 1;
    while (totalStars >= levelThreshold(lvl + 1) && lvl < 200)
        lvl++;
    return lvl;
}
/** پیشرفت داخل سطح جاری — برای نوار پیشرفت */
export function levelProgress(totalStars) {
    const level = levelForStars(totalStars);
    const base = level === 1 ? 0 : levelThreshold(level);
    const next = levelThreshold(level + 1);
    const span = Math.max(1, next - base);
    const into = Math.max(0, totalStars - base);
    return { level, into, span, pct: Math.min(100, (into / span) * 100) };
}
/** نام‌های آسمانی به‌جای عدد خشک */
const LEVEL_NAMES = [
    "شب اول", "سوسو", "کورسو", "درخشش", "شب‌تاب",
    "ستارهٔ شامگاهی", "پروین", "ناهید", "سهیل", "کهکشان",
];
export function levelName(level) {
    if (level <= LEVEL_NAMES.length)
        return LEVEL_NAMES[level - 1];
    return `${LEVEL_NAMES[LEVEL_NAMES.length - 1]} ${level - LEVEL_NAMES.length + 1}`;
}
export function sumStars(entries, localDate) {
    return entries
        .filter((e) => (localDate ? e.localDate === localDate : true))
        .reduce((s, e) => s + e.delta, 0);
}
//# sourceMappingURL=stars.js.map